module.exports = __webpack_public_path__ + "img/product5.17784d3b.png";